module.exports = __webpack_public_path__ + "img/logo.259cd64f.png";